if (!customElements.get("build-your-set")) {
  customElements.define(
    "build-your-set",
    class BuildYourSet extends HTMLElement {
      constructor() {
        super();
        this.maxNumber = parseInt(this.dataset.maxproduct, 10);
        this.bundleType = this.dataset.bundletype;
        this.maxGiftNumber = parseInt(this.dataset.maxfreeproduct, 10);
        this.enableFreeGift = this.dataset.enblefree;
        console.log(this.enableFreeGift === 'true' ,this.maxGiftNumber,"maxGiftNumber");
        /*if(this.enableFreeGift === 'true' && this.bundleType == 'bundle'){
          this.maxNumber = this.maxNumber + this.maxGiftNumber;
        }*/
        this.freeproducts = this.dataset.freeproducts;
        
       this.button = this.querySelector(".custom-bybo-add-to-cart");
        this.initEventListeners();
      }
      getSelectedItems(){
            return Array.from(this.querySelectorAll(".activated-added-item"))
          .reduce((ids, el) => {
            console.log(ids,el);
              if (el.querySelector(".js-qty__num").value > 0) {
                  ids.push({
                    id:el.querySelector(".js-qty__num").dataset.id,
                    quantity:el.querySelector(".js-qty__num").value
                  });
              }
              return ids; // Always return the accumulator (ids)
          }, []);
      }
      async addBYOBProducts(evt){
        evt.preventDefault();
        evt.stopPropagation();
        
        const productSelected = this.getSelectedProducts();
        if(productSelected.length <= 0){
          return false;
        }
       
       this.button.classList.add('btn--loading');
        let items = this.getSelectedItems();
        if( this.enableFreeGift === 'true'){
          if(this.freeproducts){
            const freeproducts = this.freeproducts.split("___");
            if(freeproducts.length > 0){
              for(let i in freeproducts){
                if(freeproducts[i]){
                  items.push({
                    "id":freeproducts[i],
                    "quantity":1
                  });
                }
              }
            }
          }
        }
        
        let formData = {
         'items': items
        };
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });
        const data = await response.json();
         this.button.classList.remove('btn--loading');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        document.querySelector(".custom-center-popup.overlay.open").classList.remove("open");
       document.body.classList.remove("custom-pack-modal-opened");
    }
      initEventListeners() {
        this.button.addEventListener("click",this.addBYOBProducts.bind(this));

        this.querySelectorAll(".custom-grid-form-wrapper .js-qty__adjust")
          .forEach((el) => {
            el.addEventListener("click", () => this.quantityChangeHandler(el));
          });
        if(this.querySelectorAll('.custom-grid-form-wrapper button.add-to-cart').length > 0){
          this.querySelectorAll('.custom-grid-form-wrapper button.add-to-cart').forEach((el) => {
              el.addEventListener("click",(evt) => {
                evt.preventDefault();
              evt.stopPropagation();
               
                  el.parentNode.classList.add("activated-added-item");
                  el.classList.add("added-item");
                  el.setAttribute("disabled","disabled");
                  el.parentNode.querySelector(".js-qty__adjust--plus").dispatchEvent(new Event("click"));
                                  
              });
          });
        }
        if(this.querySelectorAll(".custom-byob-delete-item").length > 0){
          this.querySelectorAll(".custom-byob-delete-item").forEach((el) => {
            el.addEventListener("click",(evt) => {
              let lastElement = el.dataset.selected;
              if(lastElement){
                 const buttonElement = this.querySelector(`.added-item[data-vid="${lastElement}"]`);
               
                if(buttonElement){
                  const parentElement = buttonElement.parentElement;
                  const totalQuantity = +parentElement.querySelector('.js-qty__num').value;
                  console.log(totalQuantity,"totalQuantity",buttonElement);
                  if(totalQuantity > 1){
                    parentElement.querySelector('.js-qty__num').value = (totalQuantity - 1);
                  }else{
                    buttonElement.classList.remove("added-item");
                    buttonElement.removeAttribute("disabled","disabled");
                    parentElement.querySelector('.js-qty__num').value = 0;
                    parentElement.classList.remove("activated-added-item");
                  }
                }
                
                
                this.updateState();
              }
            });
          });
        }
        if(this.querySelector(".left-grid-icon")){
           this.querySelector(".left-grid-icon").addEventListener("click", () => {
              this.querySelector('#CollectionAjaxContent').classList.add('columns-3-grid');
              this.querySelector('#CollectionAjaxContent').classList.remove('columns-4-grid');
              this.querySelector('.left-grid-icon').classList.add('active');
              this.querySelector('.right-grid-icon').classList.remove('active');
          });
        }
       
        if(this.querySelector(".right-grid-icon")){
          this.querySelector(".right-grid-icon").addEventListener("click", () => {
              this.querySelector('#CollectionAjaxContent').classList.add('columns-4-grid');
              this.querySelector('#CollectionAjaxContent').classList.remove('columns-3-grid');
              this.querySelector('.right-grid-icon').classList.add('active');
              this.querySelector('.left-grid-icon').classList.remove('active');
          });
        }
        
      }

      getTotalProductQuantity() {
        return Array.from(this.querySelectorAll(".activated-added-item"))
          .reduce((total, el) => total + (parseInt(el.querySelector(".js-qty__num").value, 10) || 0), 0);
      }

      getSelectedProducts() {
        return Array.from(this.querySelectorAll(".activated-added-item"))
          .map(el => el.querySelector(".js-qty__num").dataset.id);
      }
      

      quantityChangeHandler(el) {
        const inputElement = el.parentElement.querySelector(".js-qty__num");
        const selectedCount = this.getTotalProductQuantity();
        

        if (el.classList.contains("js-qty__adjust--plus")) {
          
          if (selectedCount < this.maxNumber) inputElement.stepUp();
        } else {
          inputElement.stepDown();
          if (parseInt(inputElement.value, 10) <= 0) {
            const parent = el.closest(".activated-added-item");
            parent?.classList.remove("activated-added-item");
            parent?.querySelector("button.add-to-cart")?.classList.remove("added-item");
          }
        }
        this.updateState();
      }

      updateState() {
        const selectedCount = this.getTotalProductQuantity();
        const productSelected = this.getSelectedProducts();
        const buttonElement = this.querySelector(".custom-bybo-add-to-cart");
        const needToSelectProduct = this.maxNumber;

        buttonElement.toggleAttribute("disabled", selectedCount !== needToSelectProduct);
        this.updateButtonMessage(buttonElement, selectedCount, needToSelectProduct);

        this.querySelectorAll(".custom-grid-form-wrapper button.add-to-cart")
          .forEach(el => el.toggleAttribute("disabled", selectedCount >= needToSelectProduct));

        this.updateProductSelection(productSelected);
        this.updateFreeGiftImage();
        
      }
      updateFreeGiftImage(){
        const selectedCount = this.getTotalProductQuantity();
         const needToSelectProduct = this.maxNumber;
        if(this.enableFreeGift === 'true'){
          if(selectedCount == needToSelectProduct){
            this.querySelectorAll(".custom-pack-footer-product-selectoin-holder-item.freegift-item").forEach((el) => {
              el.classList.add("active");
            });
          }else{
            this.querySelectorAll(".custom-pack-footer-product-selectoin-holder-item.freegift-item").forEach((el) => {
              el.classList.remove("active");
            })
          }
        }
      }

      updateButtonMessage(buttonElement, selectedCount, needToSelectProduct) {
        const remaining = needToSelectProduct - selectedCount;
        const messageText = buttonElement.querySelector(".byob-message-text");
        const messageAddText = buttonElement.querySelector(".byob-message-add-text");

        if (selectedCount === needToSelectProduct) {
          messageText.classList.add("hide");
          messageAddText.classList.remove("hide");
        } else {
          const counterHTML = `<span class="csutom-counter">${remaining}</span>`;
          messageText.innerHTML = this.getButtonText(selectedCount, remaining).replace("__COUNTER__", counterHTML);
          messageText.classList.remove("hide");
          messageAddText.classList.add("hide");
        }
      }

      getButtonText(selectedCount, remaining) {
        if (remaining === 1) return "Add __COUNTER__ more KNIVE";
        return `Add __COUNTER__ more knives`; // Adjust text based on selectedCount if needed.
      }

      updateProductSelection(productSelected) {
        let startIndex = 1;

        this.querySelectorAll(".custom-byob-footer-product-selectoin-holder-item")
          .forEach(el => {
            el.classList.remove("active");
            el.querySelector(".custom-byob-delete-item")?.removeAttribute("data-selected");
          });

        productSelected.forEach(productId => {
          const buttonElement = this.querySelector(`.added-item[data-vid="${productId}"]`);
          if (buttonElement) {
            const totalQuantity = parseInt(buttonElement.closest(".activated-added-item").querySelector(".js-qty__num").value, 10);
            for (let i = 1; i <= totalQuantity; i++) {
              const itemHolder = this.querySelector(`.custom-byob-footer-product-selectoin-holder-item[data-index="${startIndex}"]`);
              if (itemHolder) {
                itemHolder.classList.add("active");
                itemHolder.querySelector(".custom-byob-delete-item")?.setAttribute("data-selected", productId);
                itemHolder.querySelector("img.active-mode").src = buttonElement.dataset.image;
                startIndex++;
              }
            }
          }
        });
      }
    }
  );
}
